import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import { fetchHallOfFame } from 'Redux/ducks/algolia-calls';
import HallOfFameLandingPage from 'Components/HallOfFame/HallOfFameLandingPage';
import { currencyCode } from 'Helpers/Geo/data';

const HallOfFameContainer = ({ siteTheme, match: { params: { year } } }) => {
  const [hits, setHits] = useState([]);
  const [sort, setSort] = useState('top-reviewed');

  useEffect(() => {
    const fetchHits = async () => {
      const results = await fetchHallOfFame({ bestOfYear: Number(year), hitsPerPage: 100 });
      setHits(results);
    };

    fetchHits();
  }, [year]);

  if (sort === 'top-reviewed') hits.sort((a, b) => b.metacritic_score - a.metacritic_score);
  if (sort === 'best-discount') hits.sort((a, b) => (b.discount_percent || 0) - (a.discount_percent || 0));
  if (sort === 'lowest-price') hits.sort((a, b) => _get(a, `price.${currencyCode}`, 0) - _get(b, `price.${currencyCode}`, 0));

  return (
    <HallOfFameLandingPage
      sort={sort}
      hits={hits}
      setSort={setSort}
      siteTheme={siteTheme}
      bestOfYear={Number(year)}
    />
  );
};

HallOfFameContainer.propTypes = {
  siteTheme: PropTypes.string,
  year: PropTypes.string.isRequired,
};

HallOfFameContainer.defaultProps = {
  siteTheme: 'dark',
};

const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});

export default connect(mapStateToProps)(HallOfFameContainer);
